import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ManufacturerAdminModel, ManufacturerFilterSettingsModel, ManufacturerGridModel } from "../../models/manufacturer";
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import ManufacturerService from '../../services/manufacturerService';
import { ManufacturerFilter } from '../configuration/manufacturers/manufacturerFilter';

interface IProps {
    isVisible: boolean,
    cancelClick: any,
    addClick: any,
    selectedManufactorerId: number | undefined
}

interface IState {
    isLoading: boolean;
    error: any;
    manufactorers: Array<ManufacturerAdminModel>
    currentManufactorer: ManufacturerAdminModel | undefined;
    from: number;
    numberOfRows: number;
    totalRecordsCount: number;
    currentFilterSettings: ManufacturerFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class ManufactorerListDialogComponent extends React.Component<IProps, IState> {

    manufacturerService = new ManufacturerService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            error: null,
            from: initFrom,
            numberOfRows: numberOfRows,
            totalRecordsCount: 0,
            manufactorers: new Array<ManufacturerAdminModel>(),
            currentManufactorer: new ManufacturerAdminModel(),
            currentFilterSettings: new ManufacturerFilterSettingsModel()
        }
    }

    componentDidMount() {
        this.getAllFilteredItems(this.state.from, this.state.numberOfRows, this.state.currentFilterSettings);
    }

    getAllFilteredItems(from: number, numberOfRows: number, currentFilterSettings: ManufacturerFilterSettingsModel) {
        this.setState({
            isLoading: true
        });

        this.manufacturerService.getAllManufacturers(from, numberOfRows, currentFilterSettings).then(
            (data: ManufacturerGridModel) => {
                this.setState({
                    isLoading: false,
                    from: from,
                    manufactorers: data.manufacturers,
                    totalRecordsCount: data.totalRecordsCount,
                    currentManufactorer: this.props.selectedManufactorerId && this.props.selectedManufactorerId > 0 ?
                        data.manufacturers.find(r => r.manufacturerId == this.props.selectedManufactorerId) : new ManufacturerAdminModel()
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    error
                });
            });
    }

    handleOnPageClick = (e) => {
        const startIndex = e.first;
        this.getAllFilteredItems(startIndex, this.state.numberOfRows, this.state.currentFilterSettings);
    }

    handleAddButton = event => {
        event.preventDefault();
        const currentManufactorer = this.state.currentManufactorer;
        this.props.addClick(currentManufactorer);
    }

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    handleFilterChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentFilterSettings: ManufacturerFilterSettingsModel = { ...this.state.currentFilterSettings };
        currentFilterSettings[name] = value;
        this.setState({
            currentFilterSettings: { ...currentFilterSettings }
        });
    }

    handleFilterButtonClick = (settings) => {
        this.getAllFilteredItems(this.state.from, this.state.numberOfRows, settings);
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleFilterButtonClick(this.state.currentFilterSettings)
        }
    }

    handleSearchButtonClick = (settings) => {
        this.setState({
            isLoading: true
        });

        this.manufacturerService.getAllManufacturers(initFrom, numberOfRows, settings).then(
            (data: ManufacturerGridModel) => {
                this.setState({
                    isLoading: false,
                    from: initFrom,
                    manufactorers: data.manufacturers,
                    currentFilterSettings: settings,
                    totalRecordsCount: data.totalRecordsCount
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    error
                });
            });
    }

    //TODO: Add cinst for objects so to not use full this.state....
    render() {
        return (
            <Dialog header="Manufacturers" responsive={true} width="60%"
                modal={true}
                visible={this.props.isVisible}
                onHide={this.handleCancelButton}
                footer={
                    <div>
                        <Button label="Add" icon="pi pi-check" onClick={this.handleAddButton} className="p-button-raised" />
                        <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
                    </div>
                }>
                <ManufacturerFilter
                    onSearchClick={this.handleSearchButtonClick}
                    totalRecordsCount={this.state.totalRecordsCount}
                    isVisibleAlphabetic={false}
                />
                <div style={{ minHeight: '400px', maxHeight: '550px', overflowY: 'auto' }}>
                    <DataTable
                        value={this.state.manufactorers}
                        paginator={true}
                        lazy={true}
                        rows={this.state.numberOfRows}
                        totalRecords={this.state.totalRecordsCount}
                        selectionMode="single"
                        selection={this.state.currentManufactorer}
                        onPage={(event) => this.handleOnPageClick(event)}
                        onSelectionChange={(e) => this.setState({ currentManufactorer: e.data })}
                        first={this.state.from}
                        dataKey='manufacturerId'
                    //loading={props.isLoading}	
                    >
                        <Column field="name" header="Name"
                            body={(rowData, column) =>
                                rowData && rowData.manufacturerContent && rowData.manufacturerContent.length ?
                                    rowData.manufacturerContent
                                        .filter(x => typeof x.name === 'string' && x.name.length > 0)
                                        .map(r => r.name)
                                        .join(' / ')
                                    : null
                            } />
                        <Column field="country" header="Country"
                            body={(rowData, column) =>
                                rowData && rowData.manufacturerContent && rowData.manufacturerContent.length ?
                                    rowData.manufacturerContent
                                        .filter(x => typeof x.country === 'string' && x.country.length > 0)
                                        .map(r => r.country)
                                        .join(' / ')
                                    : null
                            } />
                    </DataTable>
                </div>
            </Dialog >
        )
    }

}

export default ManufactorerListDialogComponent;
